import { render, staticRenderFns } from "./GenericForm.vue?vue&type=template&id=205f2a7b"
import script from "./GenericForm.vue?vue&type=script&lang=js"
export * from "./GenericForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports